/* ==========================================================================
   Planetry Prints · secondary pages behaviour
   --------------------------------------------------------------------------
     [data-pp-studio-scope]   any block holding a Date Field and links marked
                              [data-pp-studio="print|case"]. Picking a date
                              rewrites each link to its studio with ?pp_date=
                              (plus data-pp-message / data-pp-edition when set).
                              The links work without JavaScript, minus the date.
     [data-pp-compare]        the NASA comparison slider (The science).
     [data-pp-copy="text"]    copies text, flashes data-pp-copied.
     [data-ppf]               FAQ: category rail marks the one in view.
   Everything is reduced-motion safe; nothing loops.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  function studioUrl(kind, date, extra) {
    if (window.PP && window.PP.studioUrl) return window.PP.studioUrl(kind, date, extra);
    var base = kind === 'case' ? '/products/sky-code-personalized-phone-case' : '/products/custom-planetry-art-print';
    var q = [];
    if (date) q.push('pp_date=' + encodeURIComponent(date));
    for (var k in (extra || {})) if (extra[k]) q.push(k + '=' + encodeURIComponent(extra[k]));
    return base + (q.length ? '?' + q.join('&') : '');
  }

  /* ---- date-aware studio links -------------------------------------------- */
  function updateStudioLinks(scope, date) {
    scope.querySelectorAll('[data-pp-studio]').forEach(function (a) {
      var kind = a.getAttribute('data-pp-studio');
      var d = date;
      /* The Sky Code Case takes dates from 1900 to 2050. */
      if (kind === 'case' && d && (d < '1900-01-01' || d > '2050-12-31')) d = '';
      var extra = {};
      var msg = a.getAttribute('data-pp-message');
      var ed = a.getAttribute('data-pp-edition');
      if (msg && kind === 'print') extra.pp_message = msg;
      if (ed && kind === 'case') extra.pp_edition = ed;
      a.setAttribute('href', studioUrl(kind, d, extra));
    });
  }

  doc.addEventListener('pp:datechange', function (e) {
    var scope = e.target.closest('[data-pp-studio-scope]');
    if (!scope || !e.detail) return;
    scope.setAttribute('data-pp-picked', e.detail.value);
    updateStudioLinks(scope, e.detail.value);
  });

  /* A "go" button beside a Date Field: with no date yet, open the field
     instead of leaving, so the first tap is never wasted. */
  doc.addEventListener('click', function (e) {
    var go = e.target.closest('[data-pp-studio-go]');
    if (!go) return;
    var scope = go.closest('[data-pp-studio-scope]');
    if (!scope || scope.getAttribute('data-pp-picked')) return;
    var field = scope.querySelector('[data-pp-datefield]');
    if (!field || !field.ppField) return;
    e.preventDefault();
    var control = field.querySelector('.pp-datefield__control');
    if (control) { control.focus(); control.click(); }
  });

  /* ---- copy buttons ---------------------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-copy]');
    if (!b) return;
    var text = b.getAttribute('data-pp-copy');
    var idle = b.textContent;
    var done = function () {
      b.textContent = b.getAttribute('data-pp-copied') || 'Copied';
      setTimeout(function () { b.textContent = idle; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
    else done();
  });

  /* ---- comparison slider ------------------------------------------------------ */
  function initCompare(root) {
    if (root.ppCompare) return;
    root.ppCompare = true;
    var top = root.querySelector('[data-pp-compare-top]');
    var grip = root.querySelector('[data-pp-compare-grip]');
    var handle = root.querySelector('[data-pp-compare-handle]');
    var tagN = root.querySelector('[data-pp-compare-tagn]');
    var tagP = root.querySelector('[data-pp-compare-tagp]');
    if (!top) return;
    var dragging = false;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      top.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      top.style.webkitClipPath = 'inset(0 0 0 ' + pct + '%)';
      if (handle) handle.style.left = pct + '%';
      if (grip) grip.setAttribute('aria-valuenow', Math.round(pct));
      if (tagP) tagP.style.opacity = pct > 84 ? 0 : 1;
      if (tagN) tagN.style.opacity = pct < 16 ? 0 : 1;
    }
    function fromEvent(e) {
      var rect = root.getBoundingClientRect();
      setPos(((e.clientX - rect.left) / rect.width) * 100);
    }
    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { root.setPointerCapture(e.pointerId); } catch (_) {}
      fromEvent(e);
    });
    root.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    root.addEventListener('pointerup', function () { dragging = false; });
    root.addEventListener('pointercancel', function () { dragging = false; });
    if (grip) grip.addEventListener('keydown', function (e) {
      var cur = parseFloat(grip.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setPos(cur - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setPos(cur + 4); e.preventDefault(); }
      if (e.key === 'Home') { setPos(0); e.preventDefault(); }
      if (e.key === 'End') { setPos(100); e.preventDefault(); }
    });
    root.ppCompareSet = setPos;   /* lets the science page move the divider */
    setPos(50);
  }

  /* ---- FAQ: the category rail marks the category in view ------------------- */
  function initFaq(root) {
    if (root.ppFaq || !('IntersectionObserver' in window)) return;
    root.ppFaq = true;
    var links = root.querySelectorAll('[data-ppf-link]');
    if (!links.length) return;
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        if (map[id]) map[id].setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    root.querySelectorAll('[data-ppf-group]').forEach(function (g) { io.observe(g); });
  }

  /* ---- 404: the stray planet drifts once, then rests ------------------------ */
  function init404(root) {
    if (root.pp404) return;
    root.pp404 = true;
    if (window.PP && window.PP.reduceMotion && window.PP.reduceMotion.matches) { root.classList.add('is-drifted'); return; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-drifted'); }); });
  }

  function boot(scope) {
    scope = scope || doc;
    if (window.PP && window.PP.initDateFields) window.PP.initDateFields(scope);
    scope.querySelectorAll('[data-pp-compare]').forEach(initCompare);
    scope.querySelectorAll('[data-ppf]').forEach(initFaq);
    scope.querySelectorAll('[data-pp4]').forEach(init404);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
